import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import styles from '../styles/components/footer.module.css';
import globalStyles from '../styles/global.module.css';

const Footer = () => {
  return (
    <footer className={styles.footer}>
      <div className={styles.footerContainer}>
        <div className={styles.footerContent}>
          <div className={styles.footerInfo}>
            <p className={styles.footerText}>N(N)LE Hi-Tech Business Hub ID: 402214590</p>
            <a href="/privacy" target="_blank" className={styles.footerText}>Privacy policy</a>
            <a href="https://drive.google.com/drive/folders/1iACAu_ljarZHrD4wgg5ns6uvKaSGKpFK" target="_blank" className={styles.footerText}>N(N)LE Hi-Tech Business Hub Yearly Reports</a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer; 